<template>
    <div>
        <div v-if="wrong_page_url" class="ns-wrong-page-url mt-16 mx-16">
            <div style="padding: 25px;" class="mx-auto">
                    <el-alert
                    style="margin: auto;"
                    :style="{ width: isMobile ? '100%' : '80%' }"
                    title="Something went wrong!"
                    type="error"
                    description="Oops! Wrong URL Can you please check email once or connect with admin."
                    show-icon :closable="false">
                </el-alert>
                <!-- <div class="text-center mt-5">
                    <el-button type="warning" @click="window.location.reload()">Contact</el-button>
                </div> -->
            </div>
            <!-- <p class="ns-warning-message">Oops! Wrong URL Can you please check email once or connect with admin.</p>
            <button class="ns-back-button" @click="$router.go(-1)">Back</button> -->
        </div>
        <div v-else>
            <div v-if="is_pdf_downloaded" class="mt-16 mx-16">
                <el-card elevation="2" outlined>
                   <div style="padding: 25px;" class="mx-auto">
                         <el-alert
                            style="margin: auto;"
                            :style="{ width: isMobile ? '100%' : '80%' }"
                            title="PDF downloaded successfully"
                            type="success"
                            description="If your PDF is not downloaded automatically, please click the button below."
                            show-icon :closable="false">
                        </el-alert>
                        <div class="text-center mt-5">
                            <el-button v-if="project_execution_id" type="success" @click="downloadFiveKReport(project_execution_id)">Download PDF</el-button>
                            <el-button v-else type="warning" @click="window.location.reload()">Reload</el-button>

                        </div>
                   </div>
                </el-card>
            </div>
            <div v-else class="w-full text-center mt-20 mx-16">
                <el-card elevation="2" outlined>
                   <div style="padding: 25px;" class="mx-auto">
                         <div v-loading="page_loading" class="mb-8">
                            
                         </div>
                        <el-alert
                            style="margin: auto;"
                            :style="{ width: isMobile ? '100%' : '80%' }"
                            title="PDF Generation in progress"
                            type="info"
                            description="We're currently generating the PDF. This process may take a few moments. Please be patient, and do not close or refresh this page.
                            Once the PDF is ready, you will be redirected to the confirmation page automatically. Thank you for your patience. "
                            show-icon :closable="false">
                        </el-alert>
                   </div>
                </el-card>
            </div>
            <FiveKReport v-if="checkCompany.is_bb || checkCompany.is_bt || checkCompany.is_gf" ref="fiveKReport" :meta-data="computedFiveKReportMetaData"  :data="computedFiveKReportData" :previous-data="computedFiveKReportPreviousData"/>
        </div>
    </div>
</template>

<script>
import FiveKReport from "../pdf/FiveKReport.vue";
import formBuilderServices from "../../../services/formBuilderServices";
import { mapActions } from "vuex";
import { EventBus } from "../../../eventBus";
export default {
    name: 'ProjectReportPdf',
    components: {
        FiveKReport
    },
    // Your component's script code here
    data() {
        return {
            five_k_report_data: {},
		    is_5k_data_loaded: false,
            page_loading: false,
            wrong_page_url: false,
            interval: {},
            value: 0,
            isMobile: false,
            is_pdf_downloaded: false,
            sec_count: 5,
            project_execution_id: null
        }
    },
    computed: {
        checkCompany() {
            return JSON.parse(localStorage.getItem('check_company'));
        },
        computedFiveKReportData(){
			let original_data = {...this.five_k_report_data.project_execution};
			return original_data;
		},
		computedFiveKReportMetaData(){
			let original_data = {...this.five_k_report_data.meta};
			return original_data;
		},
		computedFiveKReportPreviousData(){
			let original_data = {...this.five_k_report_data.previous_projects};
			return original_data;
		}
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.handleResize);
      EventBus.$off('pdf-downloaded');
    },
    mounted() {
        // First it check the query param is present or not named project_id
        this.page_loading = true;
        if(this.$route.query.project_execution_id){
            // If present then it call the function to get the data
            this.downloadFiveKReport(this.$route.query.project_execution_id);
            this.project_execution_id = this.$route.query.project_execution_id;
        } else {
            this.page_loading = false;
            // If not present then it will redirect to the 404 page
            this.$router.push({ path: "404" });
            this.wrong_page_url = true;
        }

        // Check if the screen size is below a certain threshold for mobile
        this.isMobile = window.innerWidth <= 600; // Adjust the threshold as needed
        // Add an event listener to handle screen size changes dynamically
        window.addEventListener('resize', this.handleResize);

        // If pdf is downloaded
        EventBus.$on('pdf-downloaded', () => {
            this.is_pdf_downloaded = true;
            // this.interval = setInterval(() => {
            //     this.sec_count--;
            //     if(this.sec_count == 0){
            //         //  Close this tab
            //         if (confirm('Download complete. Close this tab?')) {
            //             window.opener.close();
            //         }
            //     }
            // }, 1000);
        });
    },
    methods: {
        ...mapActions("CommonStore", [
			"addDownloadingReportCountAction",
			"removeDownloadingReportCountAction",
		]),
		// Function to get all five K report data
		downloadFiveKReport(id){
			let payload = { id: id };
			// this.addDownloadingReportCountAction();
            this.page_loading = true;
            this.value = 0;
			formBuilderServices.getFiveKReportPdfData(payload, (progressEvent) => {
                 // Check if the progress event is supported by the browser
                if (progressEvent && progressEvent.lengthComputable) {
                    // Calculate the progress percentage and update the value
                    const progressPercentage =
                    (progressEvent.loaded / progressEvent.total) * 100;
                    this.value = Math.min(progressPercentage, 100);
                }
            }).then((res)=>{
				this.five_k_report_data = JSON.parse(res.data);
				this.is_5k_data_loaded = true;
				this.removeDownloadingReportCountAction();
				if(this.is_5k_data_loaded && this.five_k_report_data.project_execution) {
					this.$nextTick(() => {
						// this.processPdfDownload();
						EventBus.$emit('loadPdfFirst');
					});
				}
			}).catch((err)=>{
				console.error(err);
				this.$notify.error({
					title: "Error",
					message: "Something went wrong!",
				});
                this.wrong_page_url = true;
				this.is_5k_data_loaded = false;
				// this.removeDownloadingReportCountAction(); 
			}).finally(()=>{
				
			});
		},
        handleResize() {
            // Update the isMobile property based on the screen size
            this.isMobile = window.innerWidth <= 600; // Adjust the threshold as needed
        },
    }
}
</script>

<style scoped>
@import "../../../plugins/vuetify.min.css";
.ns-wrong-page-url {
    text-align: center;
    margin-top: 20px;
}

.ns-warning-message {
    font-size: 18px;
    color: #e29d5a;
}

.ns-back-button{
    padding: 10px 20px;
    margin: 10px 0px;
    background-color: #e29d5a !important;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    color: #fff;
}

.ns-back-button {
    padding: 10px 20px;
    background-color: #ccc;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}
</style> 